module.exports = __webpack_public_path__ + "static/media/holiday-siam-4.f84f2e53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/partner-hotels/holiday-express-siam/holiday-siam-4.jpg
// module id = 729
// module chunks = 6